import Sorter from "./Sorter";
import Table from "./Table";
import TBody from "./TBody";
import Td from "./Td";
import TFoot from "./TFoot";
import Th from "./Th";
import THead from "./THead";
import Tr from "./Tr";

Table.THead = THead;
Table.TBody = TBody;
Table.TFoot = TFoot;
Table.Th = Th;
Table.Tr = Tr;
Table.Td = Td;
Table.Sorter = Sorter;

export default Table;
